import React, { useEffect, useState } from "react";
import { BookOpen } from "lucide-react";
import StoreCatalogsModal from "./StoreCatalogModal";
import PdfFirstPageThumbnail from "../Home/PdfFirstPageThumbnail";
import { setMetaDescription } from "../../utils/seo";
import api from "../../api";



const getDaysLeft = (validTo) => {
  const today = new Date();
  const end = new Date(validTo);
  const diff = Math.ceil((end - today) / (1000 * 60 * 60 * 24));
  return diff < 0 ? 0 : diff;
};

const StoreCatalogs = ({ storeId , storeName , onSelectCatalog , selectedCat}) => {
  const [catalogs, setCatalogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!storeId) return;

    const fetchCatalogs = async () => {
      try {
        const response = await api.get(
          `/store-offer/catalogue-image/catalogues/store?storeId=${storeId}`
        );

        setCatalogs(response.data || []);
      } catch (error) {
        console.error("Error fetching catalogs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCatalogs();
  }, [storeId]);

  // Set meta description for store catalogs
useEffect(() => {
  if (!catalogs || catalogs.length === 0) return;

  const firstCatalogue = catalogs[0];

  if (
    firstCatalogue?.catalogueName &&
    firstCatalogue?.validFrom &&
    firstCatalogue?.validTo
  ) {
    const formattedDate = new Date(firstCatalogue.validTo).toLocaleDateString(
      "en-GB",
      {
        day: "2-digit",
        month: "long",
      }
    );

    setMetaDescription(
      `${firstCatalogue.catalogueName} | Ends on ${formattedDate}`
    );
  }
}, [catalogs]);


 const formatDate = (dateStr) => {
  const [y, m, d] = dateStr.split("-");
  return new Date(y, m - 1, d).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
  });
};


  if (loading) return <div className="p-4">Loading catalogues...</div>;

  const visibleCatalogs = showAll ? catalogs : catalogs.slice(0, 8);



  return (
    <div className="w-full max-w-6xl mx-auto p-4">
        <div className="border rounded shadow p-2">
      <h2 className="text-xl font-semibold mb-4 border-b pb-2">
        {storeName} CATALOGS
      </h2>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
        {visibleCatalogs.map((cat) => {
          const daysLeft = getDaysLeft(cat.validTo);

          return (
            <div
              key={cat.id}
              className="border rounded-md bg-white overflow-hidden shadow hover:shadow-md transition hover:shadow-lg"
              onClick={() => {
              setShowModal(!showModal);
               onSelectCatalog(cat);
            }}
            >
              {/* Image */}
              <div className="w-full h-[326px] bg-gray-100 flex justify-center items-center relative overflow-hidden">
                
                  <div className="flex justify-center">
                  <PdfFirstPageThumbnail
                    pdfUrl={`https://api.gulf.deals/store-offer/pdf?url=${(
                      cat.catalogueImageUrl
                    )}`}
                  />
                  </div>
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-slate-900/5 to-transparent flex items-end justify-end p-1.5 opacity-0 hover:opacity-100 transition text-white">
                  <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-white/20 backdrop-blur">
                    <BookOpen className="w-3.5 h-3.5" />
                  </span>
                </div>
                

              </div>

              {/* Content */}
              <div className="p-3">
                <h3 className="font-semibold text-sm line-clamp-2 min-h-[40px]">
                  {cat.catalogueName}
                </h3>

                <p className="text-xs text-gray-500 mt-2">
                  Ends on {formatDate(cat.validTo)}
                </p>

                <span
                  className={`inline-block mt-2 text-xs px-2 py-1 rounded
                    ${
                      daysLeft <= 0
                        ? "bg-red-500 text-white"
                        : daysLeft <= 1
                        ? "bg-yellow-500 text-white"
                        : "bg-green-600 text-white"
                    }`}
                >
                  {daysLeft <= 0
                    ? "Expired"
                    : daysLeft === 1
                    ? "1 Day left"
                    : `${daysLeft} Days left`}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Footer */}
      {catalogs.length > 8 && (
        <div className="text-center mt-6">
          <button
            onClick={() => setShowAll(!showAll)}
            className="text-blue-600 hover:underline font-medium"
          >
            {showAll ? "Show Less" : "View All"}
          </button>
        </div>
      )}
      </div>
      {
        showModal && (<StoreCatalogsModal 
        onClose={() => setShowModal(!showModal)}
        catalog={selectedCat}

        />)
      }
    </div>
  );
};

export default StoreCatalogs;
